import React, { useRef, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { RefreshCw } from "lucide-react";
import api from "../../../utils/axiosInstance";
import { getApiErrorMessage } from "../../../utils/errorMessages";

export default function OrderNotificationControls({ events = [], base, onRefresh, busy = false }) {
  const [decision, setDecision] = useState(null);
  const [reason, setReason] = useState("");
  const [working, setWorking] = useState(false);
  const [error, setError] = useState("");
  const lock = useRef(false);
  async function submit(review) {
    if (lock.current) return;
    lock.current = true; setWorking(true); setError("");
    try {
      await api.post(`${base}/notifications/${review ? "review" : "retry"}`, review ? { ...review, reason } : {});
      setDecision(null); await onRefresh();
    } catch (err) { setError(getApiErrorMessage(err, { fallback: "Notification recovery failed. Refresh before retrying." })); }
    finally { lock.current = false; setWorking(false); }
  }
  const disabled = busy || working;
  return <div className="order-notifications">
    <button type="button" className="admin-order-manage__ghost-btn" disabled={disabled} onClick={() => submit(null)}><RefreshCw size={16} /> Retry queued / failed notifications</button>
    {events.length ? <details className="mt-3"><summary>Notification history</summary><ul>{events.map((event, index) => {
      const reviewable = event.status === "ambiguous" || (event.status === "pending" && Date.now() - new Date(event.lastAttemptAt || event.createdAt).getTime() >= 300000);
      return <li key={event.key || index}>{event.type}: {event.status} ({event.attempts} attempt(s))
        {reviewable ? <div className="order-operational-actions"><button type="button" disabled={disabled} onClick={() => { setReason(""); setDecision({ key: event.key, action: "mark_sent" }); }}>Record verified delivery</button>
          {!event.deliveryAcceptedAt ? <button type="button" disabled={disabled} onClick={() => { setReason(""); setDecision({ key: event.key, action: "retry_verified_unsent" }); }}>Approve retry after review</button> : null}</div> : null}
      </li>;
    })}</ul></details> : null}
    {error && !decision ? <p role="alert">{error}</p> : null}
    <Modal show={Boolean(decision)} onHide={() => { if (!disabled) setDecision(null); }} centered>
      <Form onSubmit={(event) => { event.preventDefault(); submit(decision); }}>
        <Modal.Header closeButton={!disabled}><Modal.Title>Review notification delivery</Modal.Title></Modal.Header>
        <Modal.Body><p>{decision?.action === "mark_sent" ? "Confirm delivery only after checking SMTP/provider evidence." : "Approve a retry only after verifying that this notification was not delivered. An unknown outcome must remain blocked."}</p>
          <Form.Group controlId="notification-review-reason"><Form.Label>Delivery evidence / reason</Form.Label><Form.Control as="textarea" required maxLength={1000} value={reason} onChange={(event) => setReason(event.target.value)} disabled={disabled} /></Form.Group>
          {error ? <p role="alert">{error}</p> : null}
        </Modal.Body>
        <Modal.Footer><Button variant="secondary" disabled={disabled} onClick={() => setDecision(null)}>Back</Button><Button type="submit" variant="dark" disabled={disabled || !reason.trim()}>Record decision</Button></Modal.Footer>
      </Form>
    </Modal>
  </div>;
}
